export const ProposalSubType = {
  BALANCE_DUE: 'BALANCE_DUE',
  UNFILED_RETURN: 'UNFILED_RETURN',
} as const;

export const ProposalStatus = {
  DRAFT: 'DRAFT',
  AWAITING_CUSTOMER: 'AWAITING_CUSTOMER',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
} as const;

export const ProposalSource = {
  TAX_OPS: 'TAX_OPS',
  CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
} as const;

export type ProposalSubType = (typeof ProposalSubType)[keyof typeof ProposalSubType];
export type ProposalStatus = (typeof ProposalStatus)[keyof typeof ProposalStatus];
export type ProposalSource = (typeof ProposalSource)[keyof typeof ProposalSource];

export interface ProposalItem {
  id: string;
  proposal_id: string;
  state_code: string;
  period_year: number | null;
  period_month: number | null;
  amount: string | null;
  linked_filing_id: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface Proposal {
  id: string;
  organization_id: string;
  created_by: string;
  assignee: string | null;
  sub_type: ProposalSubType;
  status: ProposalStatus;
  source: ProposalSource;
  detail: string;
  decline_reason: string | null;
  items: ProposalItem[];
  created_at: string;
  updated_at: string | null;
}

export interface ProposalItemCreatePayload {
  state_code: string;
  period_year: number | null;
  period_month: number | null;
  amount: string | null;
}

export interface ProposalCreatePayload {
  sub_type: ProposalSubType;
  source: ProposalSource;
  detail: string;
  assignee: string | null;
  items: ProposalItemCreatePayload[];
}

export interface ProposalBulkCreateRequest {
  proposals: ProposalCreatePayload[];
}

export interface ProposalItemPatchPayload {
  id: string;
  period_year: number | null;
  period_month: number | null;
  amount: string | null;
}

export interface ProposalPatchRequest {
  detail: string;
  assignee: string | null;
  items: ProposalItemPatchPayload[];
}

export interface ProposalBulkSendRequest {
  proposal_ids: string[];
}
